// extracted by mini-css-extract-plugin
module.exports = {"root":"tenth_root__2CLUd","check":"tenth_check__2YALH"};